/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/localization/labels',[], function() {
    'use strict';
    var labels = {
        others: {
            'DAY': 'Day',
            'DAYS': 'Days'
        },
        header: {
            'pdfGenerationText': 'PDF Generated On : ',
            'customDateText': 'Custom Date : ',
            'generatedLocationText': 'Generated at Location : '
        },
        footer: {
            'orgName': 'Powered by '
        },
        dashboard: {
            'title': 'Dashboard',
            'conversion': 'Conversion',
            'wifiusage': 'Wi-Fi Users',
            'demographics': 'Demographics',
            'newVsRepeatUsers': 'New Vs. Repeat Users',
            'dwellTime': 'Dwell Time',
        },
        analytics: {
            'title': 'Analytics'
        },
        analyticsChart: {},
        zoning: {
            'intraDayText': 'Intra-day Interval : ',
            'type': 'Type : ',
            'zoneName': 'Zone Name',
            'deviceName': 'Device Name',
            'radius': 'Radius (in {units})',
            'dwellTime': 'Dwell Time (Avg. in mins)',
            'footfallPerHour': 'Footfall (Avg. visitors/hour)',
            'footfallPerDay': 'Footfall (Avg. visitors/day)',
            'dimensions': 'Dimensions : '
        }
    };
    return labels;
});
